/**
 * Data Files Hook
 * მონაცემთა ფაილების ჰუკი
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getDataFiles,
  getDataFile,
  uploadDataFile,
  deleteDataFile,
  reprocessDataFile,
} from '../features/api/dataFiles';

export function useDataFiles() {
  const query = useQuery({
    queryKey: ['data-files'],
    queryFn: () => getDataFiles(),
  });

  return {
    dataFiles: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useDataFile(fileId: string) {
  const query = useQuery({
    queryKey: ['data-file', fileId],
    queryFn: () => getDataFile(fileId),
    enabled: !!fileId,
  });

  return {
    dataFile: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useUploadDataFile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      file,
      onProgress,
    }: {
      file: File;
      onProgress?: (progress: number) => void;
    }) => uploadDataFile(file, onProgress),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['data-files'] });
    },
  });
}

export function useDeleteDataFile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (fileId: string) => deleteDataFile(fileId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['data-files'] });
    },
  });
}

export function useReprocessDataFile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (fileId: string) => reprocessDataFile(fileId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['data-files'] });
    },
  });
}
